import { Box } from '@mui/material'
import LayoutWithSecondarySidebar from 'components/Layout/LayoutWithSecondarySidebar'
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator'
import { useOrder } from 'hooks/useOrders'
import { useGetPlaceName } from 'hooks/usePlaces'
import theme from 'lib/theme'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { OrderPart } from 'types/api/order'
import { OrderLabels } from './OrderLabels'
import { OrderSecondarySidebar } from './OrderSecondarySidebar'

const Order = () => {
  const { orderId } = useParams()
  const { isLoading, error, order } = useOrder(orderId as string)
  const { placeName } = useGetPlaceName(order.parts[0].placeId)

  const location = useLocation()
  const partId =
    location.pathname.split('/').length === 5
      ? location.pathname.split('/')[4]
      : null
  const orderPart = partId
    ? order.parts.filter((part: OrderPart) => part.id === partId)?.[0]
    : null
  const labels = orderPart?.labels ?? []

  if (isLoading || !order) {
    return <LoadingIndicator />
  }
  if (error) return <h1>Error</h1>

  return (
    <LayoutWithSecondarySidebar
      sx={{
        borderLeft: `1px solid ${theme.palette.neutral.grey7}`,
        height: '100%',
      }}
      sidebar={
        <OrderSecondarySidebar
          order={order}
          storeName={placeName}
          orderId={orderId as string}
        />
      }>
      <Box>
        {location.pathname.split('/').length === 5 && (
          <Box height={theme.spacing(6)} display='flex' alignItems='center'>
            <OrderLabels labels={labels} />
          </Box>
        )}
        <Outlet />
      </Box>
    </LayoutWithSecondarySidebar>
  )
}

export default Order
